import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { facilityExtrasActions, facilityInfoActions } from './visitorInformation.actions';
import { FacilityExtraDto, FacilityInfoDto, facilityInfoInit } from './visitorInformation.dtos';

const facilityInfoReducer = combineReducers({
    info: createReducer<FacilityInfoDto>(facilityInfoInit)
      .handleAction(
        [
          facilityInfoActions.success,
        ], (state, action) => action.payload),
  
    content: createReducer<FacilityExtraDto[]>([] as FacilityExtraDto[])
      .handleAction(
        [
            facilityExtrasActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default facilityInfoReducer;